import axios from 'axios';

const TOKEN_KEY = 'localbot_admin_token';
const USER_KEY = 'localbot_admin_user';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function getUsername() {
  return localStorage.getItem(USER_KEY) || '';
}

export function setAuth(token, username) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, username);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

const BASE = process.env.VUE_APP_BASE_PATH || '';
const http = axios.create({ baseURL: BASE ? `${BASE}/api` : '/api' });

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    const data = err.response?.data;
    const msg = data?.zh || data?.error || err.message;
    if (err.response?.status === 401) {
      const isLoginRequest = err.config?.url?.includes('/auth/login');
      clearToken();
      if (!isLoginRequest) {
        window.location.reload();
      }
    }
    return Promise.reject(new Error(msg));
  }
);

export const api = {
  auth: {
    login: (username, password) => http.post('/auth/login', { username, password }),
    changePassword: (oldPassword, newPassword) =>
      http.post('/auth/change-password', { oldPassword, newPassword }),
  },
  logs: {
    list: (params) => http.get('/logs', { params }),
  },
  users: {
    stats: () => http.get('/users/stats'),
    list: (params) => http.get('/users', { params }),
  },
  settings: {
    getStaff: () => http.get('/settings/staff'),
    setStaff: (staff) => http.put('/settings/staff', { staff }),
  },
  mainCategories: {
    list: (params) => http.get('/main-categories', { params }),
    create: (data) => http.post('/main-categories', data),
    update: (id, data) => http.put(`/main-categories/${id}`, data),
    remove: (id) => http.delete(`/main-categories/${id}`),
  },
  subCategories: {
    list: (params) => http.get('/sub-categories', { params }),
    create: (data) => http.post('/sub-categories', data),
    update: (id, data) => http.put(`/sub-categories/${id}`, data),
    assign: (id, main_category_id) =>
      http.put(`/sub-categories/${id}/assign`, { main_category_id }),
    remove: (id) => http.delete(`/sub-categories/${id}`),
  },
  merchants: {
    list: (params) => http.get('/merchants', { params }),
    create: (data) => http.post('/merchants', data),
    update: (id, data) => http.put(`/merchants/${id}`, data),
    assign: (id, sub_category_id) =>
      http.put(`/merchants/${id}/assign`, { sub_category_id }),
    remove: (id) => http.delete(`/merchants/${id}`),
  },
  ads: {
    broadcasts: () => http.get('/ads/broadcasts'),
    broadcastStatus: (id) => http.get(`/ads/broadcasts/${id}`),
    broadcast: (merchant_id) => http.post('/ads/broadcast', { merchant_id }),
    schedules: () => http.get('/ads/schedules'),
    createSchedule: (merchant_id, times) =>
      http.post('/ads/schedules', { merchant_id, times }),
    cancelSchedule: (id) => http.put(`/ads/schedules/${id}/cancel`),
  },
  cities: {
    list: (params) => http.get('/cities', { params }),
    create: (data) => http.post('/cities', data),
    update: (id, data) => http.put(`/cities/${id}`, data),
    remove: (id) => http.delete(`/cities/${id}`),
  },
};
